import type { Config } from "@/helpers/config";
import { useConfig } from "@/providers/config/useConfig";

import { ErrorPage } from "../Error/ErrorPage";

interface RequireFeatureFlagProps {
  flag: keyof Config;
  children: React.ReactNode;
  fallback?: React.ReactNode;
}

export function RequireFeatureFlag({
  flag,
  children,
  fallback = <ErrorPage status={404} />,
}: RequireFeatureFlagProps): React.ReactNode {
  const hasPermission = useConfig(flag);

  if (hasPermission) {
    return children;
  }

  return fallback;
}
